module.exports = __webpack_public_path__ + "img/stakanova.77d66a55.png";